import React, { useState } from 'react';
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import styled from 'styled-components';

const AccordionLeft = (props) => {
    const {
        generalInfo,
        publicProfileData,
        academicTraining,
        professionalInfo,
    } = props;

    const [expanded, setExpanded] = useState(false);

    // FUNCTION
    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    function calcularEdad(fecha) {
        var hoy = new Date();
        var cumpleanos = new Date(fecha);
        var edad = hoy.getFullYear() - cumpleanos.getFullYear();
        var m = hoy.getMonth() - cumpleanos.getMonth();

        if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
            edad--;
        }
        return edad;
    }

    return (
        <Wrapper>
            <ContactWrapper>
                <TypographyFake sx={{ width: '33%', flexShrink: 0 }}>
                    Contacto
                </TypographyFake>

                {publicProfileData?.phone && (
                    <>
                        <Tiltle>TELÉFONO PARTICULAR</Tiltle>
                        <Content>{publicProfileData.phone}</Content>
                    </>
                )}

                {publicProfileData?.mobile && (
                    <>
                        <Tiltle>TELÉFONO CELULAR</Tiltle>
                        <Content>{publicProfileData.mobile}</Content>
                    </>
                )}

                {publicProfileData?.personal_email && (
                    <>
                        <Tiltle>EMAIL</Tiltle>
                        <Content>{publicProfileData.personal_email}</Content>
                    </>
                )}

                {publicProfileData?.contacto_email_alumni && (
                    <>
                        <Tiltle>EMAIL 2</Tiltle>
                        <Content>
                            {publicProfileData.contacto_email_alumni}
                        </Content>
                    </>
                )}

                {publicProfileData?.work_email && (
                    <>
                        <Tiltle>EMAIL INSTITUCIONAL</Tiltle>
                        <Content>{publicProfileData.work_email}</Content>
                    </>
                )}

                {publicProfileData?.street && (
                    <>
                        <Tiltle>Dirección</Tiltle>
                        <Content>
                            {publicProfileData.street}
                            {' - '}
                            {publicProfileData?.city
                                ? publicProfileData.city
                                : '-'}
                            {' - '}
                            {publicProfileData?.country?.name
                                ? publicProfileData.country.name
                                : '-'}
                        </Content>
                    </>
                )}
                {publicProfileData?.country?.name && (
                    <>
                        <Tiltle>País</Tiltle>
                        <Content>{publicProfileData.country.name}</Content>
                    </>
                )}

                {publicProfileData?.city && (
                    <>
                        <Tiltle>Localidad - CIUDAD</Tiltle>
                        <Content>{publicProfileData.city}</Content>
                    </>
                )}
            </ContactWrapper>
        </Wrapper>
    );
};

export default AccordionLeft;

const Wrapper = styled.div`
    height: 100%;
    width: 100%;
    overflow-y: auto;
    row-gap: 1rem;
`;

const TypographyFake = styled(Typography)`
    color: #4f4f4f;
    font-weight: 700;
    font-size: 1.1rem;
`;

const Tiltle = styled.text`
    font-family: 'Lato';
    font-style: normal;
    font-weight: 900;
    font-size: 0.8rem;
    line-height: 0.5rem;
    align-items: center;
    text-transform: uppercase;
    font-feature-settings:
        'tnum' on,
        'lnum' on;
    color: #616161;
`;

const Content = styled.text`
    font-family: 'Lato';
    font-style: normal;
    font-weight: 400;
    font-size: 1rem;
    align-items: center;
    font-feature-settings:
        'tnum' on,
        'lnum' on;
    color: #222222;
    margin-bottom: 1.5rem;
`;

const ContactWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 1rem;
    padding: 0.5rem;
    padding-top: 1rem;
`;
